import styled from 'styled-components';
import { helpTextDanger, helpTextDefault } from '../../styles/variables';

interface HelperTextProps {
  isError?: boolean;
  size?: 'md' | 'sm' | 'lg';
}

const HelperText = styled.span<HelperTextProps>`
  color: ${({ isError }) => {
    if (isError) {
      return helpTextDanger;
    }

    return helpTextDefault;
  }};

  ${({ size }): string => {
    switch (size) {
      case 'sm':
        return `
          font-size: 10px;
          line-height: 15px;
        `;
      case 'lg':
        return `
          font-size: 16px;
          line-height: 21px;
        `;
      case 'md':
      default:
        return `
          font-size: 14px;
          line-height: 1.5;
        `;
    }
  }}
`;

export default HelperText;
